module.exports = __webpack_public_path__ + "img/logo.189df5d9.png";